// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2x_XL","disabled":"FileBtn_disabled__3vQXR","warn":"FileBtn_warn__2yWhA","fade":"FileBtn_fade__F8cAN"};